import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../commonCss/Footer.css";

const Footer = () => {
  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="mt-2 footer-f-color">
                <a href="/">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/icons/bbtnewlogo.svg"
                    alt="bbt_white"
                    className="bbt-img-footer"
                    loading="lazy"
                  />
                </a>

                <div className="row g-2 mt-3">
                  <div className="col-8">
                    <div className="d-flex gap-3">
                      <LazyLoadImage
                        effect="blur"
                        src="https://blueberrywebsites.azureedge.net/bbt/icons/newAmadeus.png"
                        alt="one"
                        className="img-fluid amadeus"
                      />
                      <LazyLoadImage
                        effect="blur"
                        src="https://blueberrywebsites.azureedge.net/bbt/icons/newSabre.png"
                        alt="one"
                        className="img-fluid sambre"
                      />
                    </div>
                    <div className="d-flex gap-3">
                      <LazyLoadImage
                        effect="blur"
                        src="https://blueberrywebsites.azureedge.net/bbt/icons/WorldTravelAwards-Logo-02.svg"
                        alt="one"
                        className="img-fluid wroldtravel"
                      />
                      <LazyLoadImage
                        effect="blur"
                        src="https://blueberrywebsites.azureedge.net/bbt/icons/newATPI%20IATA.png"
                        alt=""
                        className="atpaiata"
                      />
                      {/* <LazyLoadImage
            effect="blur"
 src={four} alt="one" className="img-fluid travelport" /> */}
                    </div>
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/newTravelPort.png"
                      alt="one"
                      className="img-fluid travelport"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                <p className="mb-4 text-white">
                  {" "}
                  <strong>GET IN TOUCH</strong>{" "}
                </p>
                <address>
                  <p className="smallfontP">
                    {" "}
                    1210-1211, Regal Tower, Business
                    <br />
                    Bay, Dubai, United Arab Emirates
                  </p>
                  <p className="smallfontP position-relative">
                    <a
                      href="mailto:info@blueberry-travel.com"
                      className="mb-2 position-relative"
                    >
                      info@blueberry-travel.com
                    </a>{" "}
                    <br />
                    <a
                      href="tel:+97147707355"
                      className="mt-2 position-relative"
                    >
                      +971 4 7707355
                    </a>
                  </p>
                  <a
                    href="https://blueberrywebsites.azureedge.net/bbt/images/QR.png"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/Footer%20Qr%20White%20New.svg"
                      alt="QR code"
                      className="h-75 qr-img"
                      loading="lazy"
                    />
                  </a>
                  <br />
                </address>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                <p className="mb-4 text-white">
                  <strong> LINKS</strong>{" "}
                </p>
                <ul className="list-unstyled smallfontP">
                  <li className="mt-2">
                    <a href="/" className="text-decoration-none footer-f-color">
                      Home
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/our-story"
                      className="text-decoration-none footer-f-color"
                    >
                      Our story
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/global-solution"
                      className="text-decoration-none footer-f-color"
                    >
                      Global Solutions
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="/corporate-travel"
                      className="text-decoration-none footer-f-color"
                    >
                      Corporate Travel Management
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="blog"
                      className="text-decoration-none footer-f-color"
                    >
                      Blogs
                    </a>
                  </li>
                  <li className="mt-2">
                    <a
                      href="contact"
                      className="text-decoration-none footer-f-color"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex justify-content-lg-center justify-content-md-start">
              <div className="mt-3 footer-f-color">
                <p className="mb-4 text-white">
                  <strong>SUBSCIBE US</strong>
                </p>
                <p className="smallfontP">
                  Subscribe to our newsletter to get our <br />
                  news & deals delivered to you.
                </p>

                <div className="email-join-container">
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="email-input"
                  />
                  <button className="join-button">JOIN</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="fotter-black">
        <div className="footer-bottom d-flex justify-content-between align-items-center">
          <p className="all-rights">
            © 2025 Blueberry Travel All rights reserved.
          </p>

          <div className="d-flex gap-footer-img">
            <a
              href="https://www.youtube.com/channel/UCQJy7sptlAs47OPwBWot3vA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footYT.svg"
                alt="youtube"
                className="position-relative social-img me-1 me-md-0"
                loading="lazy"
              />
            </a>
            <a
              href="https://wa.me/919251655411"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footWA.svg"
                alt="whatsapp"
                className="position-relative social-img ps-md-2 ms-1 ms-md-0"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.facebook.com/blueberrytravel.worldwide/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footFB.svg"
                alt="facebook"
                className="position-relative social-img"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.instagram.com/blueberry.travel/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/ffotIG.svg"
                alt="instagram"
                className="position-relative social-img"
                loading="lazy"
              />
            </a>
            <a
              href="https://x.com/trvlblueberry"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/icons/footTW.svg"
                alt="twitter"
                className="position-relative twitter-img social-img ps-md-2"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
